<div class="xi-modal__container driver-analysis-dialog__container">
  <h2 class="xi-modal__title driver-analysis-dialog__title" *transloco="let t">
    {{ t('driver-analysis-dialog.run-kda') }}
  </h2>

  <div class="driver-analysis-dialog__subtitle" *transloco="let t">
    <span class="driver-analysis-dialog__subtitle--label">{{
      t('driver-analysis-dialog.data-collection')
    }}</span>
    <span class="driver-analysis-dialog__subtitle--collection">{{
      data.collection.data.displayName
    }}</span>
  </div>

  @if (isLoading) {
    <div class="xi-loader-container__center">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="xi-modal__content driver-analysis-dialog__content">
    <ng-template #analysisStep></ng-template>
  </div>

  <div class="xi-modal__actions driver-analysis-dialog__actions" *transloco="let t">
    @if (currentStepIdx === 0) {
      <div>
        <xi-default-button
          text="{{ t('driver-analysis-dialog.cancel') }}"
          fill="text"
          buttonSize="small"
          (onClick)="cancel()"
        ></xi-default-button>
      </div>
    }
    @if (currentStepIdx > 0) {
      <div>
        <xi-default-button
          text="{{ t('driver-analysis-dialog.back') }}"
          fill="text"
          buttonSize="small"
          (onClick)="previousStep()"
        ></xi-default-button>
      </div>
    }

    <div class="driver-analysis-dialog__actions-spacer"></div>

    @if (currentStepIdx < formStateOrder.length - 1) {
      <div>
        <xi-default-button
          text="{{ t('driver-analysis-dialog.next') }}"
          buttonSize="small"
          [disabled]="!isCurrentStateValid"
          (onClick)="nextStep()"
        ></xi-default-button>
      </div>
    }
    @if (currentStepIdx === formStateOrder.length - 1) {
      <div>
        <xi-default-button
          text="{{ t('driver-analysis-dialog.run-kda') }}"
          buttonSize="small"
          [disabled]="!isCurrentStateValid"
          (onClick)="analyze()"
        ></xi-default-button>
      </div>
    }
  </div>
</div>
